






import { Component, Vue } from "vue-property-decorator";
import * as pkg from "../../package.json";

/**
 * Overlays debug information on the display.
 */
@Component
export default class Debug extends Vue {
  private version = pkg.version;
}
